/**
 * Registre des pages comparatives /vs/<concurrent>.
 *
 * Source unique : App.tsx en dérive les routes, et le pré-rendu SEO
 * (src/entry-prerender.tsx → scripts/prerender-seo.mjs) ainsi que le
 * sitemap en dérivent la liste des URL. Ajouter une page /vs/* = ajouter
 * une ligne ici, rien d'autre.
 */
import type { ComponentType } from "react";
import VsDoodle from "./VsDoodle";
import VsFramadate from "./VsFramadate";

export const VS_PAGES: Record<string, ComponentType> = {
  doodle: VsDoodle,
  framadate: VsFramadate,
};
